import { render, staticRenderFns } from "./ComponentCard.vue?vue&type=template&id=495b7bb2&scoped=true&"
import script from "./ComponentCard.vue?vue&type=script&lang=js&"
export * from "./ComponentCard.vue?vue&type=script&lang=js&"
import style0 from "./ComponentCard.vue?vue&type=style&index=0&id=495b7bb2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495b7bb2",
  null
  
)

export default component.exports